// extracted by mini-css-extract-plugin
export var divider = "_vp-0";